import { Routing } from '../../../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/js/router';
import routes from '../../../../../public/js/fos_js_routes.json';

Routing.setRoutingData(routes);

export const RoutingSymfony = Routing;
